import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-100 p-1 pt-1 pb-1 error-container a-i-center j-content-center direction-column" }
const _hoisted_2 = {
  key: 1,
  class: "w-100 text-center"
}

import { popupAccountTypeMessage } from "@/store/modules/User/type";
import TreeComponent from "./treeComponent.vue";



export default /*#__PURE__*/_defineComponent({
  __name: 'treeItemsComponent',
  props: {
    items: {}
  },
  setup(__props: any) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props?.items, (child, i) => {
      return (_openBlock(), _createElementBlock("li", {
        class: _normalizeClass('d-flex w-100 text-center'),
        key: i
      }, [
        (typeof Object.values(child) === 'object')
          ? (_openBlock(), _createBlock(TreeComponent, {
              key: 0,
              item: child
            }, null, 8, ["item"]))
          : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props?.items), 1))
      ]))
    }), 128))
  ]))
}
}

})